var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.002,
    height: 20,
    viewBox: "0 0 18.002 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_51",
    "data-name": "Union 51",
    d: "M16,19a3.368,3.368,0,0,0-1.872-2.688A9.8,9.8,0,0,0,9,15,9.8,9.8,0,0,0,3.87,16.313,3.375,3.375,0,0,0,2,19a1,1,0,1,1-2,0A4.408,4.408,0,0,1,.8,16.5a6.618,6.618,0,0,1,2.013-1.878A11.794,11.794,0,0,1,9,13a11.821,11.821,0,0,1,6.187,1.614A6.654,6.654,0,0,1,17.2,16.493,4.425,4.425,0,0,1,18,19a1,1,0,0,1-2,0ZM3,6a6,6,0,1,1,6,6A6.007,6.007,0,0,1,3,6ZM5,6A4,4,0,1,0,9,2,4,4,0,0,0,5,6Z",
    fill: "#c7cbcf"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cafa61deb3d9b04f0aa2439834f0f596.svg";
export { ForwardRef as ReactComponent };